import React, { useState, useEffect } from 'react';
import Axios from "axios";

import { MDBListGroup, MDBListGroupItem, MDBCheckbox, MDBBtn } from 'mdb-react-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import { CSVLink } from "react-csv";

import { ageRanges, backendPathEmployees, birthdayToAgeRange, germanLevels, ratings } from "../Constants";
import ExcelExport from "./ExcelExport";


function ExportEmployees() {
    const [employeeList, setEmployeeList] = useState([]);
    const [employeesGenerated, setEmployeesGenerated] = useState(false);
    const [csvData, setCSVData] = useState([]);

    const [firstName, setFirstName] = useState(0);
    const [lastName, setLastName] = useState(0);
    const [birthday, setBirthday] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState(0);
    const [license, setLicense] = useState(0);
    const [smoker, setSmoker] = useState(0);
    const [germanLevel, setGermanLevel] = useState(0);
    const [actualGermanLevel, setActualGermanLevel] = useState(0);
    const [rating, setRating] = useState(0);
    const [ratingAnnotation, setRatingAnnotation] = useState(0);
    const [recommendation, setRecommendation] = useState(0);
    const [taskAnnotation, setTaskAnnotation] = useState(0);
    const [escalation, setEscalation] = useState(0);
    const [annotation, setAnnotation] = useState(0);
    const [inactive, setInactive] = useState(0);
    const [partner, setPartner] = useState(0);
    const [nationality, setNationality] = useState(0);


    const getEmployees = (c) => {
        Axios.get(backendPathEmployees+"employees-complete.php").then((response) => {
            setEmployeeList(response.data);
            console.log(response.data);
        });
    }

    const employeeOptionsSelected = () => {
        return firstName || lastName || birthday || phoneNumber || license || smoker || germanLevel || actualGermanLevel || rating || ratingAnnotation || recommendation || taskAnnotation || escalation || annotation || inactive || nationality || partner;
    };

    const generateEmployees = () => {
        getEmployees();
    };

    const handleChange = () => {
        setEmployeesGenerated(false);
        setCSVData([]);
    };

    useEffect(() => {
        if (employeeList.length && !employeesGenerated) {
            const data = [];
            const columns = [];
            if (firstName) {
                columns.push("Vorname");
            }
            if (lastName) {
                columns.push("Nachname");
            }
            if (birthday) {
                columns.push("Alter");
            }
            if (phoneNumber) {
                columns.push("Telefonnummer");
            }
            if (license) {
                columns.push("Führerschein");
            }
            if (smoker) {
                columns.push("Raucher");
            }
            if (germanLevel) {
                columns.push("Deutschkenntnisse");
            }
            if (actualGermanLevel) {
                columns.push("tatsächliche Deutschkenntnisse");
            }
            if (rating) {
                columns.push("Bewertung");
            }
            if (ratingAnnotation) {
                columns.push("Bemerkung zur Bewertung");
            }
            if (recommendation) {
                columns.push("Empfehlung");
            }
            if (taskAnnotation) {
                columns.push("Bemerkung für erneute Einsätze");
            }
            if (escalation) {
                columns.push("Eskalationen");
            }
            if (annotation) {
                columns.push("Anmerkungen");
            }
            if (inactive) {
                columns.push("Status");
            }
            if (partner) {
                columns.push("Partner");
            }
            if (nationality) {
                columns.push("Nationalität");
            }

            data.push(columns);
            console.log(data);

            for (let i=0; i<employeeList.length; i++) {
                const row = [];
                if (firstName) {
                    row.push(employeeList[i].FirstName);
                }
                if (lastName) {
                    row.push(employeeList[i].LastName);
                }
                if (birthday) {
                    row.push(ageRanges[birthdayToAgeRange(employeeList[i].Birthday)].label);
                }
                if (phoneNumber) {
                    row.push(employeeList[i].PhoneNumber);
                }
                if (license) {
                    if (Number(employeeList[i].License)) {
                        row.push("ja");
                    }
                    else {
                        row.push("nein");
                    }
                }
                if (smoker) {
                    if (Number(employeeList[i].Smoker)) {
                        row.push("ja");
                    }
                    else {
                        row.push("nein");
                    }
                }
                if (germanLevel) {
                    row.push(germanLevels[employeeList[i].GermanLevel].label);
                }
                if (actualGermanLevel) {
                    if (Number(employeeList[i].ActualGermanLevel) === -1) {
                        row.push("");
                    }
                    else {
                        row.push(germanLevels[employeeList[i].ActualGermanLevel].label);
                    }
                }
                if (rating) {
                    if (Number(employeeList[i].Rating) === -1) {
                        row.push("");
                    }
                    else {
                        row.push(ratings[employeeList[i].Rating].label);
                    }
                }
                if (ratingAnnotation) {
                    row.push(employeeList[i].RatingAnnotation);
                }
                if (recommendation) {
                    if (Number(employeeList[i].Recommendation)) {
                        row.push("ja");
                    }
                    else {
                        row.push("nein");
                    }
                }
                if (taskAnnotation) {
                    row.push(employeeList[i].TaskAnnotation);
                }
                if (escalation) {
                    row.push(employeeList[i].Escalations);
                }
                if (annotation) {
                    row.push(employeeList[i].Annotation);
                }
                if (inactive) {
                    if (Number(employeeList[i].Inactive)) {
                        row.push("inaktiv");
                    }
                    else {
                        row.push("aktiv");
                    }
                }
                if (partner) {
                    row.push(employeeList[i].PartnerName);
                }
                if (nationality) {
                    row.push(employeeList[i].Nationality);
                }
                data.push(row);
            }
            console.log(data);
            setCSVData(data);
            setEmployeesGenerated(true);
        }
    }, [employeeList]);


    return (
        <div>

            <div className='header2'>
                <h3>Betreuungskräfte</h3>
                <MDBListGroup light>
                    <MDBListGroupItem>
                        <MDBCheckbox inline onChange={(e) => {
                            handleChange();
                            setFirstName(e.target.checked);
                            setLastName(e.target.checked);
                            setBirthday(e.target.checked);
                            setPhoneNumber(e.target.checked);
                            setLicense(e.target.checked);
                            setSmoker(e.target.checked);
                            setGermanLevel(e.target.checked);
                            setActualGermanLevel(e.target.checked);
                            setRating(e.target.checked);
                            setRatingAnnotation(e.target.checked);
                            setRecommendation(e.target.checked);
                            setTaskAnnotation(e.target.checked);
                            setEscalation(e.target.checked);
                            setAnnotation(e.target.checked);
                            setInactive(e.target.checked);
                            setPartner(e.target.checked);
                            setNationality(e.target.checked);
                        }} />
                        alles auswählen
                    </MDBListGroupItem>
                </MDBListGroup>
            </div>

            <MDBListGroup style={{ minWidth: '22rem' }} light>
                <MDBListGroupItem>
                    <MDBCheckbox inline checked={firstName} onChange={(event) => {handleChange(); setFirstName((firstName+1)%2)}} />
                    Vorname
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={lastName} onChange={(event) => {handleChange(); setLastName((lastName+1)%2)}} />
                    Nachname
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={birthday} onChange={(event) => {handleChange(); setBirthday((birthday+1)%2)}} />
                    Alter
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={phoneNumber} onChange={(event) => {handleChange(); setPhoneNumber((phoneNumber+1)%2)}} />
                    Telefonnummer
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={license} onChange={(event) => {handleChange(); setLicense((license+1)%2)}} />
                    Führerschein
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={smoker} onChange={(event) => {handleChange(); setSmoker((smoker+1)%2)}} />
                    Raucher
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={germanLevel} onChange={(event) => {handleChange(); setGermanLevel((germanLevel+1)%2)}} />
                    Deutschkenntnisse
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={actualGermanLevel} onChange={(event) => {handleChange(); setActualGermanLevel((actualGermanLevel+1)%2)}} />
                    tatsächliche Deutschkenntnisse
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={rating} onChange={(event) => {handleChange(); setRating((rating+1)%2)}} />
                    Bewertung
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={ratingAnnotation} onChange={(event) => {handleChange(); setRatingAnnotation((ratingAnnotation+1)%2)}} />
                    Bemerkung zur Bewertung
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={recommendation} onChange={(event) => {handleChange(); setRecommendation((recommendation+1)%2)}} />
                    Empfehlung
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={taskAnnotation} onChange={(event) => {handleChange(); setTaskAnnotation((taskAnnotation+1)%2)}} />
                    Bemerkung für erneute Einsätze
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={escalation} onChange={(event) => {handleChange(); setEscalation((escalation+1)%2)}} />
                    Eskalationen
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={annotation} onChange={(event) => {handleChange(); setAnnotation((annotation+1)%2)}} />
                    Anmerkungen
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={inactive} onChange={(event) => {handleChange(); setInactive((inactive+1)%2);}} />
                    Status
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={partner} onChange={(event) => {handleChange(); setPartner((partner+1)%2);}} />
                    Partner
                </MDBListGroupItem>

                <MDBListGroupItem>
                    <MDBCheckbox inline checked={nationality} onChange={(event) => {handleChange(); setNationality((nationality+1)%2);}} />
                    Nationalität
                </MDBListGroupItem>
            </MDBListGroup>

            <div className="footer export">
                {!employeeOptionsSelected() ?
                    <MDBBtn className="btn-disabled" disabled type="submit">
                        Tabelle generieren
                    </MDBBtn>
                :
                (employeesGenerated && csvData.length) ?
                    <>
                        <MDBBtn className="btn btn-csv" type="submit" onClick={() => document.getElementById("csv-link-employee").click()}>
                            <CSVLink id="csv-link-employee" filename='Betreuungskräfte' data={csvData}>
                                <FontAwesomeIcon className='btn-icon' icon={faDownload} />
                                CSV herunterladen
                            </CSVLink>
                        </MDBBtn>

                        <ExcelExport data={csvData} fileName="Betreuungskräfte" />
                    </>
                :
                    <MDBBtn className="btn" type="submit" onClick={generateEmployees}>
                        CSV generieren
                    </MDBBtn>
                }
            </div>
        </div>
    );
}

export default ExportEmployees;